import anime, {AnimeInstance} from 'animejs';
import {ConnectedComponent} from 'lowkey-component';

import OneViewScroll from '@components/helpers/OneViewScroll';
import {createApplicationState} from '@services/ApplicationState';
import {MediaQuery} from '@services/MediaQuery';
import {appSelectors} from '@store/appSlice';

export class OneView extends ConnectedComponent {
  private appState = createApplicationState();
  private mq = MediaQuery.create();
  private wrapper: HTMLDivElement | undefined = undefined;
  private upAnime: AnimeInstance | null = null;
  private downAnime: AnimeInstance | null = null;

  private ops: OneViewScroll | null = null;
  private video: HTMLVideoElement | undefined = undefined;
  private kv: HTMLDivElement | undefined = undefined;
  private videoIsFullscreen = false;

  constructor(element: HTMLDivElement) {
    super(element);
    this.onDown = this.onDown.bind(this);
    this.onUp = this.onUp.bind(this);
  }

  didMount() {
    if (this.mq.isDesktop()) {
      this.kv = document.querySelector('.js-kv') as HTMLDivElement;
      this.video = this.element?.querySelector(
        '.o-kv-video_object',
      ) as HTMLVideoElement;
      this.wrapper = document.querySelector('.wrapper') as HTMLDivElement;
      this.ops = new OneViewScroll(document.documentElement);

      this.observe(appSelectors.selectVideoIsFullscreen, (isFullscreen) => {
        this.videoIsFullscreen = isFullscreen;
      });

      if (this.element) {
        // this.element.style.opacity = 0
      }

      // this.wrapper.style.overflow = 'hidden';
      // this.wrapper.style.height = `${window.innerHeight + 2}px`
      // this.wrapper.style.height = `${window.innerHeight}px`;
      this.ops.onUp.connect(this.onUp);
      this.ops.onDown.connect(this.onDown);

      // this.observe(appSelectors.selectPageIndicatorStatus, (status) => {
      //   console.log({status})
      //   if (status === 'startShowAnimation') {
      //     this.wrapper.style.height = ''
      //     this.wrapper.style.overflow = ''
      //   }
      // })

      this.observe(appSelectors.selectIsOpenGlobalNav, (isOpen) => {
        this.ops && (this.ops.isDisabled = isOpen);
      });
    }
  }

  didUnmount() {
    if (this.wrapper) {
      // this.wrapper.style.height = '';
      // this.wrapper.style.overflow = '';
    }
    this.ops?.onUp.disconnect(this.onUp);
    this.ops?.onDown.disconnect(this.onDown);
  }

  onDown() {
    if (this.videoIsFullscreen) {
      return;
    }
    this.appState.updateOneViewStatus('down');
    this.upAnime && this.upAnime.pause();
    this.element?.classList.add('scrolled');
    this.video?.play();
    // this.downAnime = anime({
    //   complete: () => {
    //     if (this.wrapper) {
    //       this.wrapper.style.height = ''
    //       this.wrapper.style.overflow = ''
    //     }
    //   },
    //   duration: 800,
    //   easing: 'easeOutQuart',
    //   opacity: 1,
    //   // scale: 1.0,
    //   targets: this.element,
    //   // translateY: 0,
    // })
    this.appState.updateOneViewStatus('downComplete');
    if (this.wrapper) {
      // this.wrapper.style.height = '';
      // this.wrapper.style.overflow = '';
    }

    this.downAnime = anime({
      complete: () => {
        if (this.kv) {
          this.kv.style.display = 'none';
        }
      },
      duration: 500,
      easing: 'easeOutCirc',
      opacity: 0,
      targets: this.kv,
    });
  }

  onUp() {
    if (this.videoIsFullscreen) {
      return;
    }
    this.appState.updateOneViewStatus('up');
    this.downAnime?.pause();
    if (this.wrapper) {
      // this.wrapper.style.overflow = 'hidden';
      // this.wrapper.style.height = `${window.innerHeight + 2}px`;
      // this.wrapper.style.height = `${window.innerHeight}px`
    }
    this.element?.classList.remove('scrolled');
    this.video?.pause();
    // this.upAnime = anime({
    //   duration: 800,
    //   easing: 'easeOutQuart',
    //   opacity: 0,
    //   // scale: 1.05,
    //   targets: this.element,
    // })

    if (this.kv) {
      // this.kv.style.visibility = 'visible'
      this.kv.style.display = 'block';
    }
    this.upAnime = anime({
      duration: 500,
      easing: 'easeOutCubic',
      opacity: 1,
      targets: this.kv,
      complete: () => {
        this.appState.updateOneViewStatus('upComplete');
      },
    });
  }
}
